(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-video-device"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initHeroCarousels = (root = document) => {
      root.querySelectorAll('[data-hero-carousel]').forEach((carousel) => {
        if (carousel.dataset.carouselReady === 'true') return;
        carousel.dataset.carouselReady = 'true';

        const slides = Array.from(carousel.querySelectorAll('[data-hero-slide]'));
        const prev = carousel.querySelector('[data-hero-prev]');
        const next = carousel.querySelector('[data-hero-next]');
        if (!slides.length) return;

        let index = 0;

        let transitioning = false;
        const mobileMedia = window.matchMedia('(max-width: 749px)');
        let heroVisible = true;

        const show = (nextIndex, direction = 'next', immediate = false) => {
          if (transitioning && !immediate) return;

          const targetIndex = (nextIndex + slides.length) % slides.length;
          const previousIndex = index;
          if (targetIndex === previousIndex && !immediate) return;

          const previousSlide = slides[previousIndex];
          const nextSlide = slides[targetIndex];

          const playVideoFor = (slide, active) => {
            const video = slide.querySelector('video');
            if (!video) return;

            if (active && (!mobileMedia.matches || (heroVisible && !document.hidden))) {
              video.currentTime = 0;
              video.muted = true;
              video.playsInline = true;
              const playPromise = video.play();
              if (playPromise && typeof playPromise.catch === 'function') {
                playPromise.catch(() => {});
              }
            } else {
              video.pause();
            }
          };

          if (immediate) {
            slides.forEach((slide, i) => {
              slide.classList.remove('is-exiting-left', 'is-exiting-right', 'enter-from-left', 'enter-from-right');
              slide.classList.toggle('is-active', i === targetIndex);
              playVideoFor(slide, i === targetIndex);
            });
            index = targetIndex;
            return;
          }

          transitioning = true;

          previousSlide.classList.remove('enter-from-left', 'enter-from-right');
          previousSlide.classList.add(direction === 'next' ? 'is-exiting-left' : 'is-exiting-right');
          previousSlide.classList.remove('is-active');

          nextSlide.classList.remove('is-exiting-left', 'is-exiting-right');
          nextSlide.classList.add(direction === 'next' ? 'enter-from-right' : 'enter-from-left');
          playVideoFor(previousSlide, false);

          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              nextSlide.classList.add('is-active');
              nextSlide.classList.remove('enter-from-left', 'enter-from-right');
              playVideoFor(nextSlide, true);
            });
          });

          index = targetIndex;

          window.setTimeout(() => {
            previousSlide.classList.remove('is-exiting-left', 'is-exiting-right');
            transitioning = false;
          }, 640);
        };

        show(0, 'next', true);

        if (mobileMedia.matches && 'IntersectionObserver' in window) {
          const viewportObserver = new IntersectionObserver(([entry]) => {
            heroVisible = entry.isIntersecting;
            const activeVideo = slides[index].querySelector('video');
            if (!activeVideo) return;

            if (!heroVisible || document.hidden) {
              activeVideo.pause();
            } else if (activeVideo.paused) {
              const playPromise = activeVideo.play();
              if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(() => {});
            }
          }, { threshold: 0 });
          viewportObserver.observe(carousel);

          document.addEventListener('shopify:section:unload', (event) => {
            if (event.target.contains(carousel)) viewportObserver.disconnect();
          });
        }

        if (prev) prev.addEventListener('click', () => show(index - 1, 'prev'));
        if (next) next.addEventListener('click', () => show(index + 1, 'next'));

        let touchStartX = 0;
        let touchStartY = 0;

        carousel.addEventListener('touchstart', (event) => {
          const touch = event.changedTouches[0];
          touchStartX = touch.clientX;
          touchStartY = touch.clientY;
        }, { passive: true });

        carousel.addEventListener('touchend', (event) => {
          const touch = event.changedTouches[0];
          const deltaX = touch.clientX - touchStartX;
          const deltaY = touch.clientY - touchStartY;

          if (Math.abs(deltaX) < 45 || Math.abs(deltaX) <= Math.abs(deltaY)) return;

          if (deltaX < 0) {
            show(index + 1, 'next');
          } else {
            show(index - 1, 'prev');
          }
        }, { passive: true });
      });
    };

    initHeroCarousels();
    document.addEventListener('shopify:section:load', (event) => initHeroCarousels(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["high-resolution-pdf"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initPdfSections = (root = document) => {
      root.querySelectorAll('.unreal-pdf-feature').forEach((section) => {
        if (section.dataset.pdfSectionReady === 'true') return;
        section.dataset.pdfSectionReady = 'true';

        section.querySelectorAll('[data-pdf-download]').forEach((link) => {
          if (link.dataset.pdfReady === 'true') return;
          link.dataset.pdfReady = 'true';

          link.addEventListener('click', async (event) => {
            const href = link.getAttribute('href');
            if (!href) return;

            event.preventDefault();

            try {
              const response = await fetch(href, { credentials: 'omit' });
              if (!response.ok) throw new Error('PDF download failed');

              const blob = await response.blob();
              const blobUrl = URL.createObjectURL(blob);
              const temp = document.createElement('a');
              temp.href = blobUrl;
              temp.download = href.split('/').pop().split('?')[0] || 'UNREAL-SKIN-document.pdf';
              document.body.appendChild(temp);
              temp.click();
              temp.remove();
              URL.revokeObjectURL(blobUrl);
            } catch (error) {
              window.location.assign(href);
            }
          });
        });

        const image = section.querySelector('.unreal-pdf-feature__image');
        const enabled = section.dataset.scrollMotion === 'true';
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const strength = Math.max(12, Math.min(60, Number(section.dataset.motionStrength) || 34));

        if (!image || !enabled || reduceMotion) return;

        let ticking = false;

        const update = () => {
          ticking = false;

          const rect = section.getBoundingClientRect();
          const viewport = window.innerHeight || document.documentElement.clientHeight;
          const total = viewport + rect.height;
          const progress = Math.max(0, Math.min(1, (viewport - rect.top) / Math.max(total, 1)));

          const isMobile = window.matchMedia('(max-width: 749px)').matches;
          const mobileFactor = isMobile ? 0.72 : 1;

          // 0 = section entering viewport, 1 = section leaving viewport.
          // Scroll down reveals a wider frame; scrolling up reverses naturally.
          const zoomInScale = isMobile ? 1.40 : 1.56;
          const zoomOutScale = isMobile ? 1.045 : 1.03;
          const scale = zoomInScale + (zoomOutScale - zoomInScale) * progress;

          const y = (0.5 - progress) * strength * 0.28 * mobileFactor;
          const rotate = (0.5 - progress) * 0.18 * mobileFactor;

          image.style.setProperty('--lady-y', y.toFixed(2) + 'px');
          image.style.setProperty('--lady-scale', scale.toFixed(4));
          image.style.setProperty('--lady-rotate', rotate.toFixed(3) + 'deg');
        };

        const requestUpdate = () => {
          if (ticking) return;
          ticking = true;
          window.requestAnimationFrame(update);
        };

        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              window.addEventListener('scroll', requestUpdate, { passive: true });
              window.addEventListener('resize', requestUpdate, { passive: true });
              requestUpdate();
            } else {
              window.removeEventListener('scroll', requestUpdate);
              window.removeEventListener('resize', requestUpdate);
            }
          });
        }, { rootMargin: '20% 0px 20% 0px' });

        observer.observe(section);

        section._unrealPdfDestroy = () => {
          observer.disconnect();
          window.removeEventListener('scroll', requestUpdate);
          window.removeEventListener('resize', requestUpdate);
        };
      });
    };

    initPdfSections();

    document.addEventListener('shopify:section:load', (event) => {
      initPdfSections(event.target);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      const section = event.target.querySelector('.unreal-pdf-feature');
      if (section && typeof section._unrealPdfDestroy === 'function') {
        section._unrealPdfDestroy();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premium-featured-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initPremiumFeatured = (root = document) => {
      root.querySelectorAll('.unreal-premium-featured').forEach((section) => {
        if (section.dataset.premiumReady === 'true') return;
        section.dataset.premiumReady = 'true';

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        section.dataset.revealReady = 'true';

        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              section.dataset.visible = 'true';
              observer.disconnect();
            }
          });
        }, { threshold: .16 });

        observer.observe(section);
      });
    };

    initPremiumFeatured();
    document.addEventListener('shopify:section:load', (event) => initPremiumFeatured(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc-video-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initUgcSections = (root = document) => {
      root.querySelectorAll('.unreal-ugc').forEach((section) => {
        if (section.dataset.ugcReady === 'true') return;
        section.dataset.ugcReady = 'true';

        const track = section.querySelector('[data-ugc-track]');
        const prevButton = section.querySelector('[data-ugc-prev]');
        const nextButton = section.querySelector('[data-ugc-next]');
        const autoScroll = section.dataset.autoScroll === 'true' && window.matchMedia('(max-width: 749px)').matches;
        const autoplayPreviews = section.dataset.autoplayPreviews === 'true';
        const delay = Math.max(2000, (Number(section.dataset.autoScrollDelay) || 4) * 1000);
        const mobile = window.matchMedia('(max-width: 749px)').matches;
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        let timer = null;
        let resumeTimer = null;
        let modalOpen = false;
        let sectionVisible = false;
        let hoverPaused = false;
        let isDragging = false;
        let dragMoved = false;
        let dragStartX = 0;
        let dragStartScrollLeft = 0;

        const previewVideos = () => section.querySelectorAll('.unreal-ugc__preview-video');
        const items = () => Array.from(section.querySelectorAll('[data-ugc-item]'));

        const playPreviews = () => {
          if (!autoplayPreviews || reduceMotion || modalOpen || !sectionVisible) return;
          const videos = Array.from(previewVideos());
          if (!videos.length) return;
          const trackRect = track ? track.getBoundingClientRect() : null;
          let bestVideo = videos[0];
          let bestDistance = Number.POSITIVE_INFINITY;
          videos.forEach((video) => {
            video.muted = true;
            video.loop = false;
            video.playsInline = true;
            const rect = video.getBoundingClientRect();
            const distance = trackRect ? Math.abs(rect.left - trackRect.left) : 0;
            if (distance < bestDistance) {
              bestDistance = distance;
              bestVideo = video;
            }
          });
          videos.forEach((video) => {
            if (video === bestVideo) {
              const promise = video.play();
              if (promise && typeof promise.catch === 'function') promise.catch(() => {});
            } else {
              video.pause();
            }
          });
        };

        const pausePreviews = () => {
          previewVideos().forEach((video) => video.pause());
        };

        const playSequence = (index = 0) => {
          if (!mobile || modalOpen || !sectionVisible || document.hidden) return;
          const videos = Array.from(previewVideos());
          const cards = items();
          if (!videos.length || !cards.length) return;
          const normalized = (index + videos.length) % videos.length;
          videos.forEach((video, i) => {
            video.pause();
            video.loop = false;
            if (i !== normalized) video.currentTime = 0;
          });
          scrollToCard(normalized, false);
          const active = videos[normalized];
          active.currentTime = 0;
          active.muted = true;
          active.playsInline = true;
          active.onended = () => playSequence((normalized + 1) % videos.length);
          const promise = active.play();
          if (promise && typeof promise.catch === 'function') promise.catch(() => {});
        };

        const stopAuto = () => {
          if (timer) {
            window.clearTimeout(timer);
            timer = null;
          }
        };

        const currentIndex = () => {
          const cards = items();
          if (!track || cards.length === 0) return 0;
          const trackLeft = track.getBoundingClientRect().left;
          let nearestIndex = 0;
          let nearestDistance = Number.POSITIVE_INFINITY;

          cards.forEach((card, index) => {
            const distance = Math.abs(card.getBoundingClientRect().left - trackLeft);
            if (distance < nearestDistance) {
              nearestDistance = distance;
              nearestIndex = index;
            }
          });

          return nearestIndex;
        };

        const scrollToCard = (index, manual = true) => {
          const cards = items();
          if (!track || cards.length < 2) return;

          const normalized = (index + cards.length) % cards.length;
          const target = cards[normalized];

          track.scrollTo({
            left: Math.max(0, target.offsetLeft - track.offsetLeft - 18),
            behavior: 'smooth'
          });

          if (manual) pauseForInteraction(2600);
        };

        const resetToStart = (manual = true) => {
          if (!track) return;

          track.scrollTo({
            left: 0,
            behavior: 'smooth'
          });

          if (manual) pauseForInteraction(2600);
        };

        const goNext = (manual = true) => {
          const cards = items();
          if (!track || cards.length < 2) return;

          const current = currentIndex();
          const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 12;

          if (atEnd || current >= cards.length - 1) {
            resetToStart(manual);
            return;
          }

          scrollToCard(current + 1, manual);
        };

        const goPrev = (manual = true) => {
          const cards = items();
          if (!track || cards.length < 2) return;

          const current = currentIndex();

          if (current <= 0) {
            scrollToCard(cards.length - 1, manual);
            return;
          }

          scrollToCard(current - 1, manual);
        };

        const scheduleAuto = () => {
          stopAuto();
          if (!autoScroll || reduceMotion || modalOpen || hoverPaused || !sectionVisible || document.hidden) return;

          timer = window.setTimeout(() => {
            goNext(false);
            window.setTimeout(playPreviews, 380);
            scheduleAuto();
          }, delay);
        };

        const pauseForInteraction = (ms = 4500) => {
          stopAuto();
          if (resumeTimer) window.clearTimeout(resumeTimer);
          resumeTimer = window.setTimeout(scheduleAuto, ms);
        };

        if (track) {
          track.addEventListener('touchstart', () => pauseForInteraction(5000), { passive: true });
          track.addEventListener('touchend', () => { pauseForInteraction(2200); window.setTimeout(playPreviews, 220); }, { passive: true });
          track.addEventListener('wheel', () => pauseForInteraction(3500), { passive: true });

          track.addEventListener('pointerdown', (event) => {
            if (event.pointerType !== 'mouse') return;
            isDragging = true;
            dragMoved = false;
            dragStartX = event.clientX;
            dragStartScrollLeft = track.scrollLeft;
            track.style.cursor = 'grabbing';
            stopAuto();

            if (track.setPointerCapture) {
              track.setPointerCapture(event.pointerId);
            }
          });

          track.addEventListener('pointermove', (event) => {
            if (!isDragging || event.pointerType !== 'mouse') return;

            const delta = event.clientX - dragStartX;
            if (Math.abs(delta) > 4) {
              dragMoved = true;
              event.preventDefault();
            }

            track.scrollLeft = dragStartScrollLeft - delta;
          });

          const finishDrag = (event) => {
            if (!isDragging || event.pointerType !== 'mouse') return;

            isDragging = false;
            track.style.cursor = 'grab';

            if (track.hasPointerCapture && track.hasPointerCapture(event.pointerId)) {
              track.releasePointerCapture(event.pointerId);
            }

            pauseForInteraction(2200);
          };

          track.addEventListener('pointerup', finishDrag);
          track.addEventListener('pointercancel', finishDrag);

          track.addEventListener('mouseenter', () => {
            hoverPaused = true;
            stopAuto();
          });

          track.addEventListener('mouseleave', () => {
            hoverPaused = false;

            if (isDragging) {
              isDragging = false;
              track.style.cursor = 'grab';
            }

            scheduleAuto();
          });
        }

        if (prevButton) {
          prevButton.addEventListener('click', () => {
            goPrev();
          });
        }

        if (nextButton) {
          nextButton.addEventListener('click', () => {
            goNext();
          });
        }

        section.addEventListener('click', (event) => {
          const trigger = event.target.closest('[data-ugc-open]');
          if (!trigger || !section.contains(trigger)) return;
          if (dragMoved) {
            event.preventDefault();
            dragMoved = false;
            return;
          }

          const dialog = document.getElementById(trigger.dataset.ugcOpen);
          if (!dialog) return;

          modalOpen = true;
          stopAuto();
          pausePreviews();
          dialog.showModal();

          const video = dialog.querySelector('video');
          if (video) {
            video.currentTime = 0;
            const promise = video.play();
            if (promise && typeof promise.catch === 'function') promise.catch(() => {});
          }
        });

        section.querySelectorAll('[data-ugc-dialog]').forEach((dialog) => {
          const onClose = () => {
            const video = dialog.querySelector('video');
            if (video) video.pause();
            modalOpen = false;
            if (mobile) playSequence(currentIndex()); else playPreviews();
          };

          dialog.querySelectorAll('[data-ugc-close]').forEach((button) => {
            button.addEventListener('click', () => dialog.close());
          });

          dialog.addEventListener('click', (event) => {
            if (event.target === dialog) dialog.close();
          });

          dialog.addEventListener('close', onClose);
          dialog.addEventListener('cancel', onClose);
        });

        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            sectionVisible = entry.isIntersecting && entry.intersectionRatio > 0.15;

            if (sectionVisible) {
              if (mobile) {
                playSequence(currentIndex());
              } else {
                playPreviews();
              }
            } else {
              pausePreviews();
              stopAuto();
            }
          });
        }, { threshold: [0, 0.15, 0.5] });

        observer.observe(section);

        const onVisibilityChange = () => {
          if (document.hidden) {
            stopAuto();
            pausePreviews();
          } else {
            playPreviews();
            scheduleAuto();
          }
        };

        document.addEventListener('visibilitychange', onVisibilityChange);

        section._ugcDestroy = () => {
          stopAuto();
          if (resumeTimer) window.clearTimeout(resumeTimer);
          observer.disconnect();
          document.removeEventListener('visibilitychange', onVisibilityChange);
        };
      });
    };

    initUgcSections();

    document.addEventListener('shopify:section:load', (event) => {
      initUgcSections(event.target);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      const section = event.target.querySelector('.unreal-ugc');
      if (section && typeof section._ugcDestroy === 'function') section._ugcDestroy();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
